export default __webpack_public_path__ + "static/media/mainBg.516d471d.png";